import { useTranslation } from "next-i18next";
import React from "react";
import Spinner from "../../Spinner";

function Loading() {
  const { t } = useTranslation("common");

  return (
    <div className="flex gap-4 items-center">
      <Spinner bgColor="purple" />
      <span className="text-purple highlightText capitalize">
        {t("loading")}
      </span>
    </div>
  );
}

export default Loading;
